import { compact } from "lodash";
import type { PaywallFormRequest } from "@/react/api/paywallApi";
import type { TestimonialProperty } from "@/react/types/PaywallCustomization";
import type { PaywallForm } from "../../types/PaywallForm";

const filterPaywallPrices = (priceAttribute: any) => {
  if (priceAttribute.tmp_id) {
    return priceAttribute;
  }
  if (priceAttribute._destroy) {
    return { id: priceAttribute.id, _destroy: 1 };
  }
  if (priceAttribute._updated) {
    return { id: priceAttribute.id, preferred: priceAttribute.preferred };
  }

  return null;
};

export const getValidTestimonials = (
  testimonial: TestimonialProperty,
): TestimonialProperty | null => {
  const { name, headline, quote } = testimonial;

  if (
    [undefined, null, ""].includes(name) &&
    name === headline &&
    headline === quote
  ) {
    return null;
  }

  return testimonial;
};

export const serializePaywallJson = (
  paywall: PaywallForm,
): PaywallFormRequest => {
  const paywallGroupField = {
    paywall_group_id: paywall?.enable_subscription_group
      ? paywall.paywall_group_id
      : null,
  };

  const paywallCustomization = paywall.paywall_customization_attributes || {};

  return {
    publish: paywall.publish,
    paywall: {
      ...paywall,
      ...paywallGroupField,
      stripe_prices_attributes: paywall.stripe_prices_attributes
        .map(filterPaywallPrices)
        .filter((e: any) => e),

      paywall_customization_attributes: {
        ...paywallCustomization,
        testimonial_properties: {
          enabled:
            paywallCustomization?.testimonial_properties?.enabled || false,
          testimonials: compact(
            (
              paywallCustomization?.testimonial_properties?.testimonials || []
            ).map(getValidTestimonials),
          ),
        },
      },
    },
  };
};
